import { useTranslation } from 'react-i18next';
import AiFeature from '../components/ai/AiFeature/AiFeature';
import LightRays from '../components/effects/LightRays/LightRays';
import ContactSection from '../components/site/ContactSection/ContactSection';
import PageHero from '../components/ui/PageHero/PageHero';
import Section from '../components/ui/Section/Section';
import SectionHeader from '../components/ui/SectionHeader/SectionHeader';
import { projectsWithAi } from '../data/projects';
import { usePageMeta } from '../hooks/usePageMeta';
import type { TitledText } from '../locales/types';
import styles from './Ai.module.css';

export default function Ai() {
    const { t } = useTranslation();
    usePageMeta(t('meta.aiTitle'), t('meta.aiDescription'));

    const principles = t('ai.principles.items', { returnObjects: true }) as unknown as TitledText[];

    return (
        <>
            <PageHero title={t('ai.intro.title')} lead={t('ai.intro.lead')} backdrop={<LightRays />} />

            <Section theme="light" shape="sheet" labelledBy="ai-features-title">
                <div className="page-inner">
                    <SectionHeader id="ai-features-title" title={t('ai.features.title')} lead={t('ai.features.lead')} />
                    <div className={styles.features}>
                        {projectsWithAi().map((project) => <AiFeature key={project.slug} project={project} />)}
                    </div>
                </div>
            </Section>

            <Section theme="dark" shape="sheet" labelledBy="ai-principles-title">
                <div className="page-inner">
                    <SectionHeader id="ai-principles-title" title={t('ai.principles.title')} />
                    <ul className={styles.principles}>
                        {principles.map((principle) => (
                            <li key={principle.title} className={styles.principle}>
                                <h3 className={styles.principleTitle}>{principle.title}</h3>
                                <p>{principle.body}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </Section>

            <ContactSection />
        </>
    );
}
